import { ApiError, PaginatedApiResponse } from "@/lib/apiClient";
import * as couponService from "@/services/couponService";
import {
  ACTIVATE_COUPON_FAILURE,
  ACTIVATE_COUPON_REQUEST,
  ACTIVATE_COUPON_SUCCESS,
  Coupon,
  DEACTIVATE_COUPON_FAILURE,
  DEACTIVATE_COUPON_REQUEST,
  DEACTIVATE_COUPON_SUCCESS,
  FETCH_COUPONS_FAILURE,
  FETCH_COUPONS_REQUEST,
  FETCH_COUPONS_SUCCESS,
} from "@/types/coupon";
import { CouponFilters } from "@/types/coupon/filter";
import { call, put, takeLatest } from "redux-saga/effects";

function* fetchCouponsSaga(action: {
  type: string;
  payload: {
    page: number;
    page_size: number;
    filters?: CouponFilters;
  };
}) {
  try {
    const { page, page_size, filters } = action.payload;

    // Prepare API parameters
    const params: Record<string, string | number | boolean> = {
      page: page.toString(),
      page_size: page_size.toString(),
    };

    // Add filters if provided
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params[key] = value;
        }
      });
    }

    const response: PaginatedApiResponse<Coupon[]> = yield call(
      couponService.getCoupons,
      params,
    );

    yield put({
      type: FETCH_COUPONS_SUCCESS,
      payload: {
        list: response.data,
        pagination: response.pagination,
      },
    });
  } catch (error) {
    yield put({
      type: FETCH_COUPONS_FAILURE,
      payload:
        error instanceof ApiError ? error.message : "Failed to fetch coupons",
    });
  }
}

function* activateCouponSaga(action: { type: string; payload: string }) {
  try {
    yield call(couponService.activateCoupon, action.payload);
    yield put({
      type: ACTIVATE_COUPON_SUCCESS,
      payload: action.payload,
    });
  } catch (error) {
    console.error("Saga error in activateCouponSaga:", error);
    yield put({
      type: ACTIVATE_COUPON_FAILURE,
      payload:
        error instanceof ApiError ? error.message : "Failed to activate coupon",
    });
  }
}

function* deactivateCouponSaga(action: { type: string; payload: string }) {
  try {
    yield call(couponService.deActivateCoupon, action.payload);
    yield put({
      type: DEACTIVATE_COUPON_SUCCESS,
      payload: action.payload,
    });
  } catch (error) {
    yield put({
      type: DEACTIVATE_COUPON_FAILURE,
      payload:
        error instanceof ApiError
          ? error.message
          : "Failed to deactivate coupon",
    });
  }
}

export function* couponSaga() {
  yield takeLatest(FETCH_COUPONS_REQUEST, fetchCouponsSaga);
  yield takeLatest(ACTIVATE_COUPON_REQUEST, activateCouponSaga);
  yield takeLatest(DEACTIVATE_COUPON_REQUEST, deactivateCouponSaga);
}
